var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"},on:{"click":_vm.close}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{attrs:{"aria-hidden":"true"}},[_c('i',{staticClass:"fa fa-times text-white"})])
}]

export { render, staticRenderFns }